<div class="banner" [ngStyle]="{ 'background-position-y':this.scrollBanner}"></div>
<div class="container">
    <div class="left">
        <h2>Médecin spécialiste en Gastro-entérologie</h2>
        <h3>Je prends en charge le diagnostic et le traitement des maladies de l’appareil digestif :</h3>
        <div class="list">
            <ul class="listLeft">
                <li>Œsophage</li>
                <li>Estomac</li>
                <li>Intestins</li>
                
            </ul>
            <ul class="listLeft">
                <li>Anus</li>
                <li>Colon</li>
            </ul>
            <ul class="listLeft">
                <li>Foie</li>
                <li>Pancréas</li>
            </ul>
        </div>
        <h3>Je pratique différents examens médicaux :</h3>
        <div class="examens">
            <ul class="listExam">
                <li>Consultations</li>
                <li>Gastroscopie</li>
            </ul>
            <ul class="listExam">
                <li>Colonoscopie</li>
                <li>Proctologie</li>
            </ul>
            <button id="infoButton" routerLink="/infos"><mat-icon id="helpIco">help</mat-icon> Plus d'infos</button>
        </div>
        
    </div>
    <div class="portait">
        <!-- <ng-image-slider [images]="imageObject" #nav [infinite]="true"
        [autoSlide]="8"
        [imagePopup]="false"
        [manageImageRatio]="true"
        [imageSize]="{width: '100%',height: '56%'}"
        [showArrow]="false"
        slideImage="1" ></ng-image-slider> -->
    </div>
</div> 


<div class="localisations">
    <div class="loc loc1">
        <mat-icon class="iconLoc"> location_on</mat-icon> 
        <p class="t1">Cabinet privé Andenne</p>
        <em>Avenue Reine Elisabeth 103<br>5300 Andenne</em>
        <p class="details" routerLink="adresses"><mat-icon> map</mat-icon>Détails</p>
    </div>
    <div class="loc loc2">
        <mat-icon class="iconLoc"> location_on</mat-icon> 
        <p class="t1">Cabinet médical Huy</p>
        <em>Rue des Augustins 20<br>4500 Huy</em>
        <p class="details" routerLink="adresses"><mat-icon> map</mat-icon>Détails</p>
    </div>
    <div class="loc loc3">
        <mat-icon class="iconLoc"> location_on</mat-icon> 
        <p class="t1">Centre Hospitalier régional de Huy</p>
        <em>Rue des trois ponts 2<br>4500 Huy</em>
        <p class="details" routerLink="adresses"><mat-icon> map</mat-icon>Détails</p>
    </div>
</div>
<footer>
    <div class="footbar"></div>
</footer>
